import React from 'react';

interface EmployeeProvidedScheduleInputProps {
  startTime: string;
  endTime: string;
  onStartChange: (value: string) => void;
  onEndChange: (value: string) => void;
  context: 'incorrect' | 'no-schedule';
  minDateTime?: string;
  maxDateTime?: string;
}

const EmployeeProvidedScheduleInput: React.FC<EmployeeProvidedScheduleInputProps> = ({
  startTime,
  endTime,
  onStartChange,
  onEndChange,
  context,
  minDateTime,
  maxDateTime
}) => {
  const startLabel = context === 'incorrect' ? 'Schedule start time' : 'Schedule start time';
  const endLabel   = context === 'incorrect' ? 'Schedule end time'   : 'Schedule end time';

  return (
    <div className="form-group">
      <label>Please provide correct schedule information.</label>
      <div className="row">
        <div className="col-6 col-lg-6 mb-2">
          <label htmlFor="employeeProvidedStart">* {startLabel}:</label>
          <input
            id="employeeProvidedStart"
            type="datetime-local"
            className="form-control"
            value={startTime}
            onChange={(e) => onStartChange(e.target.value)}
            min={minDateTime}
            max={maxDateTime}
          />
        </div>
        <div className="col-6 col-lg-6 mb-2">
          <label htmlFor="employeeProvidedEnd">* {endLabel}:</label>
          <input
            id="employeeProvidedEnd"
            type="datetime-local"
            className="form-control"
            value={endTime}
            onChange={(e) => onEndChange(e.target.value)}
            min={minDateTime}
            max={maxDateTime}
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeeProvidedScheduleInput;
